/**
 * Hook for authenticated API calls
 *
 * This is a thin wrapper that returns the shared api instance from authenticatedApi.
 * The shared instance has proper token refresh serialization, 401 retry logic,
 * and OAuth error handling.
 *
 * IMPORTANT: Do not create new axios instances here. All API calls should use
 * the same shared instance to ensure consistent error handling and prevent
 * race conditions during token refresh.
 */
import { api } from '../services/authenticatedApi';

/**
 * Returns the shared authenticated API instance.
 *
 * The shared instance provides:
 * - Token refresh serialization via pendingRefreshPromise (prevents race conditions)
 * - Automatic 401 retry with fresh token
 * - OAuth token expiration handling (dispatches oauth:token-expired event)
 * - Email verification handling (dispatches auth:email-verification-required event)
 * - Tenant ID header for multitenancy
 * - PostHog distinct_id for analytics correlation
 */
export const useAuthenticatedApi = () => {
  return api;
};
